import { FormSelectOption } from "@carrotfertility/carotene-core-x"
import { useIntl } from "react-intl"
import useGetBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { Benefit } from "#/lib/carrot-api/types/Benefit"

export function useGetSexOptions(): FormSelectOption[] {
  const benefitConfiguration = useGetBenefit()
  const intl = useIntl()
  return (
    [
      { label: intl.formatMessage({ defaultMessage: "Male" }), value: "MALE" },
      { label: intl.formatMessage({ defaultMessage: "Female" }), value: "FEMALE" },
      {
        label: intl.formatMessage({ defaultMessage: "Intersex" }),
        value: "INTERSEX",
        filterFunc: (b: Benefit) => b?.generalSupport?.showLgbtqContent
      }
    ]
      // Ensure that the options do not have a filterFunction or that the filterFunction returns true
      .filter((b) => !b.filterFunc || b.filterFunc(benefitConfiguration?.data))
      // Remove any filterFunctions from each option before returning the options array
      // This is to prevent console errors
      .map((optionObj) => {
        const { filterFunc: _, ...rest } = optionObj
        return rest
      })
  )
}
